import React, { useState } from 'react';
import { PageText, PageButton, PaginationContain } from './OrdersStyled';

const usePagination = (items) => {
  const pageSize = 10;
  const [page, setPage] = useState(0);

  const pages = items ? Math.ceil(items.length / pageSize) : 0;

  const filteritems = () => items.slice(page * pageSize, page * pageSize + pageSize);

  const handleResetPage = () => setPage(0);
  const handlePageClick = (page) => {
    setPage(page);
  };

  const renderPageButtons = () => {
    var buttons = [];

    for (let i = 0; i < pages; i++) {
      buttons.push(
        <PageButton
          isSelected={page === i}
          onClick={handlePageClick.bind(null, i)}
          key={i}
        >{`${i + 1}`}</PageButton>
      );
    }

    return buttons;
  };

  const renderPagination = () => {
    return (
      <PaginationContain>
        <PageText>Page {`${page + 1} of ${pages || 1}`}</PageText>
        <div>{renderPageButtons()}</div>
      </PaginationContain>
    );
  };

  return [renderPagination, filteritems(), handleResetPage];
};

export default usePagination;
